<ng-container cdkDrag cdkDragRootElement=".cdk-overlay-pane">
	<div cdkDragHandle class="mep-dialog-header-icon">
		<mat-icon>comment</mat-icon>
	</div>
	<div class="mep-dialog-title">
		{{ _lang("add-staffing-comment") }}
	</div>
	<div class="mep-dialog-content" mat-dialog-content>
		<div class="mep-text-big">
			<mat-form-field class="w-100">
				<mat-label>{{ _lang("comment") }}</mat-label>
				<textarea #value [(ngModel)]="comment.value" id="textbox" matInput required rows="5"></textarea>
				@if (displayErrorMessage) {
					<mat-error>{{ _lang("require-comment") }}</mat-error>
				}
			</mat-form-field>
		</div>
	</div>
	<div class="mep-dialog-actions">
		<button (click)="closeDialog()" appEscapeHotkey class="mep-btn-dialog-secondary">
			{{ "mep.components.general.cancel" | translate }}
		</button>
		<button (click)="save(value)" appSaveHotkey class="mep-btn-dialog-primary">
			{{ "mep.components.general.add" | translate }}
		</button>
	</div>
</ng-container>
